import React from 'react';

export default function GizlilikPolitikasi() {
    const pdfUrl = `${process.env.PUBLIC_URL}/docs/iade.pdf`;

    return (
        <div className="max-w-3xl mx-auto py-12 px-4 h-screen">
            <h1 className="font-display text-3xl text-[var(--ink)] mb-6">Iade Degisim Politikası</h1>
            <object
                data={pdfUrl}
                type="application/pdf"
                width="100%"
                height="100%"
            >
                <p>
                    Tarayıcınız PDF görüntüleyemiyor.{' '}
                    <a href={pdfUrl} target="_blank" rel="noopener noreferrer">
                        PDF’i indir
                    </a>
                    .
                </p>
            </object>
        </div>
    );
}
